export default __webpack_public_path__ + "static/media/note.49b866b2.png";